<div class="text-input-form">
  <h2 mat-dialog-title>{{ data.title }}</h2>
  
  <mat-dialog-content>
    <!-- Text Input -->
    <mat-form-field class="text-input-field" appearance="outline">
      <mat-label>{{ data.placeholder }}</mat-label>
      <input 
        matInput 
        [(ngModel)]="text" 
        [placeholder]="data.placeholder"
        #textInput>
    </mat-form-field>

    <!-- Style Options -->
    <div class="style-options">
      <h4>Text Styling</h4>
      
      <!-- Font Weight and Alignment -->
      <div class="style-row">
        <label>Format:</label>
        <div class="style-buttons">
          <button 
            mat-stroked-button
            class="style-button"
            [color]="style.fontWeight === 'bold' ? 'primary' : ''"
            (click)="toggleBold()"
            matTooltip="Bold">
            <mat-icon>format_bold</mat-icon>
          </button>
        </div>
        
        <label style="margin-left: 16px;">Alignment:</label>
        <div class="style-buttons">
          <button 
            mat-stroked-button
            class="style-button"
            [color]="style.textAlign === 'left' ? 'primary' : ''"
            (click)="setAlignment('left')"
            matTooltip="Align Left">
            <mat-icon>format_align_left</mat-icon>
          </button>
          <button 
            mat-stroked-button
            class="style-button"
            [color]="style.textAlign === 'center' ? 'primary' : ''"
            (click)="setAlignment('center')"
            matTooltip="Align Center">
            <mat-icon>format_align_center</mat-icon>
          </button>
          <button 
            mat-stroked-button
            class="style-button"
            [color]="style.textAlign === 'right' ? 'primary' : ''"
            (click)="setAlignment('right')"
            matTooltip="Align Right">
            <mat-icon>format_align_right</mat-icon>
          </button>
        </div>
      </div>

      <!-- Font Size -->
      <div class="style-row">
        <label>Font Size:</label>
        <mat-form-field appearance="outline" style="width: 100px;">
          <mat-select [(ngModel)]="style.fontSize">
            <mat-option value="12px">12px</mat-option>
            <mat-option value="14px">14px</mat-option>
            <mat-option value="16px">16px</mat-option>
            <mat-option value="18px">18px</mat-option>
            <mat-option value="20px">20px</mat-option>
            <mat-option value="24px">24px</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <!-- Colors -->
      <div class="style-row">
        <label>Colors:</label>
        <div class="color-inputs">
          <mat-form-field class="color-input" appearance="outline">
            <mat-label>Text Color</mat-label>
            <input matInput type="color" [(ngModel)]="style.color">
          </mat-form-field>
          <mat-form-field class="color-input" appearance="outline">
            <mat-label>Background Color</mat-label>
            <input matInput type="color" [(ngModel)]="style.backgroundColor">
          </mat-form-field>
        </div>
      </div>

      <!-- Preview -->
      <div style="margin-top: 16px;">
        <label>Preview:</label>
        <div class="preview-text" [ngStyle]="getPreviewStyle()">
          {{ text || data.placeholder }}
        </div>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions">
    <button mat-button (click)="onCancel()">Cancel</button>
    <button 
      mat-raised-button 
      color="primary" 
      (click)="onSave()"
      [disabled]="!isValidInput()">
      Add Text
    </button>
  </mat-dialog-actions>
</div>